import React from 'react'
import { FormattedMessage } from 'react-intl'

import { NAME_BY_DIRECTION_SPELLED } from 'helpers/i18n.jsx'

export const FORT_BATTLE_TOOLTIP_TITLE = (direction) => {
    return (
        <FormattedMessage
            id='fort_battle_tooltip.title'
            defaultMessage='Наступление с {direction} плацдарма'
            values={{
                direction: NAME_BY_DIRECTION_SPELLED[direction],
            }}
        />
    )
}

export const FORT_BATTLE_TOOLTIP_BONUS = (
    <FormattedMessage
        id='fort_battle_tooltip.bonus_text'
        defaultMessage='Удвоенный промресурс за первую победу в день при Наступлении с этого плацдарма'
    />
)

export const FORT_BATTLE_TOOLTIP_ENGAGED = (
    <FormattedMessage
        id='fort_battle_tooltip.engaged'
        defaultMessage='Плацдарм занят другим отрядом клана'
    />
)

export const FORT_BATTLE_TOOLTIP_SELECTED = (
    <FormattedMessage
        id='fort_battle_tooltip.selected'
        defaultMessage='Текущий плацдарм'
    />
)



// WEBPACK FOOTER //
// ./components/BattleWizard/components/FortBattleTooltip/constants.jsx